var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(-6619 -2669)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(6619 2669)",
    fill: "#006dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_note",
    "data-name": "vuesax/linear/note",
    transform: "translate(6197.092 2423.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note",
    transform: "translate(428 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.469-.75a.75.75,0,0,1,.75.75.634.634,0,0,0,.188.451.634.634,0,0,0,.451.188H6.019A.64.64,0,0,0,6.658,0a.75.75,0,0,1,.75-.75A3.38,3.38,0,0,1,9.63-.1a3.143,3.143,0,0,1,1,2.567V8.489a3.132,3.132,0,0,1-.983,2.5,3.318,3.318,0,0,1-2.237.723H2.469a3.318,3.318,0,0,1-2.237-.723,3.132,3.132,0,0,1-.983-2.5V2.469A3.143,3.143,0,0,1,.247-.1,3.38,3.38,0,0,1,2.469-.75ZM7.408,10.208c1.205,0,1.719-.514,1.719-1.719V2.469c0-1.16-.389-1.566-1.12-1.681a2.143,2.143,0,0,1-1.988,1.35H3.858a2.125,2.125,0,0,1-1.512-.627A2.138,2.138,0,0,1,1.869.789C1.139.9.75,1.309.75,2.469V8.489c0,1.205.514,1.719,1.719,1.719Z",
    transform: "translate(2.469 2.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.389-.75H3.55a2.139,2.139,0,0,1,0,4.278H1.389a2.139,2.139,0,1,1,0-4.278ZM3.55,2.028A.639.639,0,0,0,3.55.75H1.389a.639.639,0,0,0,0,1.278Z",
    transform: "translate(4.939 1.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.469.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H2.469a.75.75,0,0,1,.75.75A.75.75,0,0,1,2.469.75Z",
    transform: "translate(4.939 8.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.939.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H4.939a.75.75,0,0,1,.75.75A.75.75,0,0,1,4.939.75Z",
    transform: "translate(4.939 10.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H14.816V14.816H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjIcon);
export default __webpack_public_path__ + "static/media/proj-icon.9d9b6595d76a7d24f8f236e77c5f05d0.svg";
export { ForwardRef as ReactComponent };